export default function(status) {
    const titles = {
        preparing: 'Подготовка',
        approving: 'Согласование',
        approved: 'Согласовано',
        signing: 'Подписание',
        signed: 'Подписано',
        rework: 'На доработку',
        declined: 'Отказ',
        need_payment: 'Требуется оплата',
        paid: 'Оплачено',
        accrued: 'Начислено',
        draft: 'Черновик',
        pending: 'Ожидание',
        completed: 'Выполнено',
        failed: 'Ошибка',
        canceled: 'Отмена',
        done: 'Готово',
        in_progress: 'В процессе',
        partially_error: 'Неполные данные',
        error: 'Ошибка',
        rejected: 'Отклонено',
    }
    return titles[status];
}
